import { Apple, PlayCircle } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { STORE_LINKS } from "@/data/links";

export const DownloadButton = ({ children, className, testId, align = "center" }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" data-testid={testId} className={className}>
          {children}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align} className="min-w-[200px] rounded-2xl p-2">
        <DropdownMenuItem asChild className="rounded-xl py-2.5 cursor-pointer">
          <a href={STORE_LINKS.ios} target="_blank" rel="noreferrer" data-testid={`${testId}-ios`}>
            <Apple size={16} /> App Store (iOS)
          </a>
        </DropdownMenuItem>
        <DropdownMenuItem asChild className="rounded-xl py-2.5 cursor-pointer">
          <a href={STORE_LINKS.android} target="_blank" rel="noreferrer" data-testid={`${testId}-android`}>
            <PlayCircle size={16} /> Google Play (Android)
          </a>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
